import { ComponentType, SVGProps } from "react";
import {
  TriangleAlert,
  CircleCheck,
  CircleAlert,
  CheckCircle,
  LogIn,
  Building2,
  ChevronRight,
  ChevronLeft
} from "lucide-react";

export type TMsIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export type TMsIconName = (typeof MS_ICONS)[number];

export type TMsIconSize = "S" | "M" | "L" | number;

export type TMsIconType = "success" | "warning" | "error" | "info";

export const MS_ICON_SIZE_MAP: Record<TMsIconSize, number> = {
  S: 24,
  M: 48,
  L: 60
};

export const MS_ICONS = [
  "triangle-alert",
  "circle-check",
  "circle-alert",
  "product-benefit",
  "log-in",
  "organisation",
  "chevron-right",
  "chevron-left"
] as const;

export const MS_ICON_MAP: Record<TMsIconName, TMsIconComponent> = {
  "triangle-alert": TriangleAlert,
  "circle-check": CircleCheck,
  "circle-alert": CircleAlert,
  "product-benefit": CheckCircle,
  "log-in": LogIn,
  "organisation": Building2,
  "chevron-right": ChevronRight,
  "chevron-left": ChevronLeft
};
